import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getSingleEmployeeRole } from '../../redux/actions/employee';

import EmployeeRoleDetailPage from './EmployeeRoleDetail.page';

const mapStateToProps = state => ({
  employeeRoleDetail: state.organization.detailRoleEmployee,
  loading: state.organization.loading,
  error: state.organization.error,
});

const mapDispatchToProps = {
  getSingleEmployeeRole,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EmployeeRoleDetailPage));
